import { AsyncPipe } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { FloorplanTransmitter } from "@domain/project/floorplan/floorplan-transmitter";
import { FloorplanTransmitterPlaceholder } from "@domain/project/floorplan/floorplan-transmitter-placeholder";
import { FormDirective, FormFieldComponent, FormFieldControlDirective } from "@odx/angular/components/form-field";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { Observable, withLatestFrom } from "rxjs";

@Component({
  selector: "app-floorplan-transmitter-radius-form",
  imports: [AsyncPipe, FormDirective, FormFieldComponent, FormFieldControlDirective, ReactiveFormsModule, UiKitModule],
  templateUrl: "./floorplan-transmitter-radius-form.component.html",
})
export class FloorplanTransmitterRadiusFormComponent implements OnInit {
  @Input() transmitter!: FloorplanTransmitter | FloorplanTransmitterPlaceholder;
  private formBuilder = inject(FormBuilder);
  private floorplanService = inject(FloorplanService);

  protected monitoringAreaRadiusForm!: FormGroup;
  protected isReferenceMeasureSet$!: Observable<boolean>;
  protected readonly tooltipTextNoReferenceMeasure: string = $localize`:@@floorplan.referenceMeasure.noReferenceMeasureIsSet:Ein Referenzmaß ist für Änderungen erforderlich`;

  ngOnInit() {
    this.isReferenceMeasureSet$ = this.floorplanService.isReferenceMeasureSet$;

    this.initMonitoringAreaRadiusForm();
  }

  private initMonitoringAreaRadiusForm() {
    this.monitoringAreaRadiusForm = this.formBuilder.group({
      radius: [this.transmitter.referenceMonitoringAreaRadius],
    });

    this.transmitter.monitoringAreaRadiusChanged.subscribe(({ radius }) => {
      this.monitoringAreaRadiusForm.patchValue({ radius: radius }, { emitEvent: false });
    });

    this.monitoringAreaRadiusForm.valueChanges
      .pipe(withLatestFrom(this.isReferenceMeasureSet$))
      .subscribe(([values, isReferenceMeasureSet]) => {
        if (!isReferenceMeasureSet) {
          return;
        }
        if (values.radius && this.hasReferenceRadiusChanged(values.radius)) {
          this.transmitter.updateMonitoringAreaRadius(values.radius);
        }
      });
  }

  private hasReferenceRadiusChanged(referenceRadius: number) {
    return !(referenceRadius === this.transmitter.referenceMonitoringAreaRadius);
  }
}
